import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import Select from 'components/forms/Select';
import { resultsToOptions } from 'utils/misc';
import { getOutlets } from 'redux/actions/contactActions';


const OutletsFilter = ({
  outlets, getOutletsAction, value, onChange,
}) => {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    (async () => {
      await getOutletsAction({ search: null, status: true });
    })();
  }, []);

  const handleLoadOptions = async (filterString) => {
    setLoading(true);
    await getOutletsAction({ search: filterString, status: true });
    setLoading(false);
  };

  return (
    <Select
      isMulti
      placeholder="Outlets"
      value={value}
      onChange={onChange}
      cacheOptions
      defaultOptions
      options={resultsToOptions(outlets.results, 'name') || []}
      isLoading={loading}
      onInputChange={input => handleLoadOptions(input, true)}
    />
  );
};

OutletsFilter.propTypes = {
  outlets: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  getOutletsAction: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.shape({})),
  onChange: PropTypes.func.isRequired,
};

OutletsFilter.defaultProps = {
  outlets: {
    results: [],
  },
  value: [],
};


export default compose(connect(
  state => ({
    outlets: state.outlets,
  }),
  { getOutletsAction: getOutlets },
))(OutletsFilter);
